import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InnovationHeadingRoutingModule } from './innovationheading-routing.module';
import { InnovationheadingListComponent } from './innovationheading-list/innovationheading-list.component';
import { InnovationheadingCreateComponent } from './innovationheading-create/innovationheading-create.component';

@NgModule({
  declarations: [InnovationheadingListComponent, InnovationheadingCreateComponent],
  imports: [
    CommonModule,
    InnovationHeadingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InnovationHeadingModule { }
